import React from "react";

export type Layout = "single" | "stack" | "2col" | "grid";

export function LayoutWrapper({ layout, children }: { layout: Layout; children: React.ReactNode }) {
  switch (layout) {
    case "single":
    case "stack":
      return <div className="flex flex-col gap-4 w-full">{children}</div>;
    case "2col":
      return <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">{children}</div>;
    case "grid":
      return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">{children}</div>;
  }
}
